import cn from 'classnames';
import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { mobileNavigationButtonClassName } from '../constants';

type MobileMonthNavigationProps = {
  canGoToPreviousMonth: boolean;
  canGoToNextMonth: boolean;
  onPreviousMonthClick: () => void;
  onNextMonthClick: () => void;
};

export function MobileMonthNavigation({
  canGoToPreviousMonth,
  canGoToNextMonth,
  onPreviousMonthClick,
  onNextMonthClick,
}: MobileMonthNavigationProps): JSX.Element {
  return (
    <>
      <button
        type="button"
        onClick={onPreviousMonthClick}
        disabled={!canGoToPreviousMonth}
        className={cn(
          mobileNavigationButtonClassName,
          'absolute left-0 top-1/2 -translate-y-1/2 -translate-x-[calc(var(--button-size-regular)/2)]',
        )}
        aria-label="Previous month"
      >
        <MaterialIcon icon="arrow_left_alt" />
      </button>
      <button
        type="button"
        onClick={onNextMonthClick}
        disabled={!canGoToNextMonth}
        className={cn(
          mobileNavigationButtonClassName,
          'absolute right-0 top-1/2 -translate-y-1/2 translate-x-[calc(var(--button-size-regular)/2)]',
        )}
        aria-label="Next month"
      >
        <MaterialIcon icon="arrow_right_alt" />
      </button>
    </>
  );
}
